<header [class.hide-header]="isHeaderHidden">
  <div class="flex-row" id="app-header">
    <div id="app-header-logo">
      <a href="{{environment.portalHomeUrl}}" (click)="onLogoClick()">
        <img id="logo" src="assets\images\icbc-logo.svg">
      </a>
    </div>
    <div id="app-header-title">
      <a href="{{environment.portalHomeUrl}}" (click)="onMyICBCClick()">My ICBC</a>
    </div>
    <div *ngFor="let tab of tabs | keyvalue: keepOrder" class="tabs">
      <button mat-button [disableRipple]="true" (click)="routeTo(tab.value.routePath, tab.value.viewValue)"
              [ngClass]="tab.key == 'dl' ? 'selected' : ''" *ngIf="tab.key != 'support'">
        {{ tab.value.viewValue }}
      </button>
    </div>
    <div id="app-header-end">
      <button mat-icon-button id="support-btn" (click)="routeTo(tabs.support.routePath, tabs.support.viewValue)">
        <mat-icon svgIcon="support"></mat-icon>
      </button>
      <button mat-icon-button [ngClass]="isOverlayOpen ? 'selected' : ''"
              (click)="onPplIconClick(); isOverlayOpen = !isOverlayOpen" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
        <mat-icon id="profile-icon"
                  svgIcon="user-profile" [ngClass]="isOverlayOpen ? 'open' : ''"></mat-icon>
        <mat-icon id="menu-icon">{{ isOverlayOpen ? 'close' : 'menu' }}</mat-icon>
      </button>
    </div>
    <ng-template
      cdkConnectedOverlay
      cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
      (backdropClick)="isOverlayOpen = false"
      [cdkConnectedOverlayHasBackdrop]="true"
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="isOverlayOpen"
      [cdkConnectedOverlayPositions]="[
                {
                    originX: 'end',
                    originY: 'bottom',
                    overlayX: 'end',
                    overlayY: 'top',
                    offsetX: 50
                },
                {
                    originX: 'end',
                    originY: 'bottom',
                    overlayX: 'end',
                    overlayY: 'top'
                },
                {
                    originX: 'end',
                    originY: 'bottom',
                    overlayX: 'end',
                    overlayY: 'top',
                    offsetX: 20
                }
            ]">
      <div id="profile-overlay" [class.hidden-header]="isHeaderHidden">
        <div cdkMenu id="nav-menu">
          <a cdkMenuItem *ngFor="let tab of tabs | keyvalue: keepOrder"
             [href]="environment.portalHomeUrl + tab.value.routePath">
            {{ tab.value.viewValue }}
          </a>
        </div>
        <h2>
          HI{{
            firstName() ? ', ' + firstName() : '!'
          }}
        </h2>
        <div id="last-login" class="mb-16"
             *ngIf="lastSigninTimestamp() as lastLoginDate">
          <strong>You last signed in on:</strong>
          <span class="mb-16">{{ lastLoginDate | date:"MMMM d, yyyy 'at' h:mm a 'PST'" }}</span>
        </div>
        <button (click)="signOut()" mat-flat-button type="submit" class="overlay-btn">
          Sign out
        </button>
        <button (click)="onManageAccountClick()" mat-stroked-button type="submit" class="overlay-btn">
          Manage account settings
        </button>
        <span id="icbc-redirect">
          <a href="http://www.icbc.com" (click)="onReturnToICBCClick('http://www.icbc.com')">Return to icbc.com</a>
          <i class="material-icons">keyboard_arrow_right</i>
        </span>
      </div>
    </ng-template>
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="isOverlayOpen"
      [cdkConnectedOverlayPositions]="[
                {
                    originX: 'center',
                    originY: 'bottom',
                    overlayX: 'center',
                    overlayY: 'top',
                    offsetY: 25
                }
            ]">
      <div id="triangle" [class.hidden-header]="isHeaderHidden"></div>
    </ng-template>
  </div>
  <div class="flex-row" class="app-subheader">
    <div id="app-subheader-title">{{ title }}</div>
  </div>
</header>
